import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';
import classnames from 'classnames';
import { WorkPropTypes } from '../../config/proptypes';
import Work from '../find_works/work';
import WorkTitle from '../work_details/work_title';
import AddToCanvasButtons from '../find_works/add_to_canvas';
import Const from '../../config/const';
import * as findClasses from '../find_works/classes.module.scss';
import * as detailsClasses from '../work_details/classes.module.scss';
import PanelLayout from '../panel/layout';
import * as shared from '../assets/shared.module.scss';
import * as classes from './classes.module.scss';
import PinButton from '../shared/pin';
import BackButton from '../shared/back';

export default class MoreLikeThis extends PureComponent {
  static propTypes = {
    sourceId: PropTypes.number,
    loading: PropTypes.bool.isRequired,

    hideMoreLikeThis: PropTypes.func.isRequired,
    loadMoreLikeThis: PropTypes.func.isRequired,
    showMoreLikeThis: PropTypes.func.isRequired,
    addToCanvas: PropTypes.func.isRequired,

    original: PropTypes.shape({
      artistName: PropTypes.string,
      authorName: PropTypes.string,
      imageUrl: PropTypes.string,
      title: PropTypes.string,
      id: PropTypes.number,
      workSizesAttributes: PropTypes.object,
      workSizes: PropTypes.array,
      landscape: PropTypes.bool
    }),
    works: PropTypes.arrayOf(PropTypes.shape(WorkPropTypes)),

    pinned: PropTypes.bool.isRequired,
    togglePin: PropTypes.func.isRequired,
    showWorks: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { large: true };
  }

  componentDidMount() {
    const { loadMoreLikeThis } = this.props;
    loadMoreLikeThis();
  }

  componentDidUpdate({ sourceId: sourceIdWas }) {
    const { sourceId, loadMoreLikeThis } = this.props;
    if (sourceId && sourceId !== sourceIdWas) {
      loadMoreLikeThis();
    }
  }

  onToggle = () => this.setState(({ large }) => ({
    large: !large
  }));

  addToCanvas = (workSizeId, width, height) => {
    const {
      original: { id }, addToCanvas, hideMoreLikeThis, pinned
    } = this.props;
    addToCanvas({
      workId: id, workSizeId, width, height
    });
    if (!pinned) {
      hideMoreLikeThis();
    }
  };

  addToCanvasAndClose = (opts) => {
    const { addToCanvas, hideMoreLikeThis, pinned } = this.props;
    addToCanvas(opts);
    if (!pinned) {
      hideMoreLikeThis();
    }
  };

  renderLoader() {
    const { loading } = this.props;
    if (!loading) { return null; }
    return (
      <div className={ findClasses.loader }>
        <Loader active inline />
      </div>
    );
  }

  renderWorks() {
    const { works, showMoreLikeThis } = this.props;
    return (works || []).map((w, index) => (
      <Work
        addToCanvas={ this.addToCanvasAndClose }
        showMoreLikeThis={ showMoreLikeThis }
        key={ w.id }
        index={ index }
        moreSource={ Const.moreLikeThisSources.more }
        { ...w }
      />
    ));
  }

  render() {
    const {
      hideMoreLikeThis, original, pinned, togglePin, showWorks
    } = this.props;
    if (!original) {
      return null;
    }
    const {
      artistName: authorName, authorName: authorName2,
      imageUrl, title, workSizesAttributes, workSizes, landscape
    } = original;
    const workTitleProps = { authorName: authorName || authorName2, imageUrl, title };
    const { large } = this.state;

    if (!workSizesAttributes && !workSizes) {
      return null;
    }

    const rendeTitle = (
      <>
        <div className={ detailsClasses.content }>
          <WorkTitle { ...workTitleProps } large={ large }>
            <div className={ classes.sizes }>
              <AddToCanvasButtons
                workSizesAttributes={ workSizesAttributes || workSizes }
                landscape={ landscape }
                addToCanvas={ this.addToCanvas }
              />
            </div>
          </WorkTitle>

        </div>
        <BackButton
          onClick={ showWorks }
        />
        <PinButton pinned={ pinned } togglePin={ togglePin } />
      </>
    );

    const headerChildren = (
      <h4 className={ classnames(shared.h4, classes.subTitle) }>
        <span>
          More like&nbsp;
          &quot;
          { title }
          &quot;
        </span>
        <button
          type="button"
          className={ large ? classes.large : classes.small }
          onClick={ this.onToggle }
        >
          &laquo;
        </button>
      </h4>
    );

    return (
      <PanelLayout
        onClose={ hideMoreLikeThis }
        title={ rendeTitle }
        headerClass={ classes.headerClass }
        headerChildren={ headerChildren }
      >
        <div className={ findClasses.container }>
          <div className={ findClasses.wHolder }>
            <div className={ findClasses.works }>
              { this.renderWorks() }
              { this.renderLoader() }
            </div>
          </div>
        </div>

      </PanelLayout>
    );
  }
}
